<template>
  <Card>
    <template #content>
        <div id="overlay" v-if="loading">
          <div class="spinner"></div>
          <br/>
          <h4>Loading...</h4>
        </div>
          <form >
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-2">
                 <label for="toDate">As On</label>
                 <date-picker v-model="toDate" valueType="format" v-if="!englishDateEnabled"/>
                 <input-mask mask="9999-99-99" type="text" v-else class="nepali-calendar form-control" id="toDate" v-model="toDate"/>
              </div>
              <div class="p-field p-col-12 p-md-1 p-mt-5">
                 <Button type="submit"  @click.prevent="searchCostCenterSummary"
                 class="p-button-raised" label="Search" icon="pi pi-search"/>
               </div>
               <!-- <div class="p-field p-col-12 p-md-1 p-mt-5">
                 <Button @click.prevent="reset" v-if="this.costCenterSummaryLists.length > 0"
                 class="p-button-raised p-button-warning" label="Reset" icon="pi pi-refresh"/>
              </div> -->
          </div>
        </form>
        <div>
          <TreeTable :value="costCenterSummaryLists" sortMode="multiple">
            <Column header="Cost Center" :sortable="true" field="name" :expander="true"></Column>
            <Column header="Debit" :sortable="true" field="debitBalance" ></Column>
            <Column header="Credit" :sortable="true" field="creditBalance" ></Column>
            <!-- <Column header="Action">
              <template >
                <Button class="p-button-raised p-button-success" icon="pi pi-pencil"
                        @click.prevent="openBasic"
                />
                <Button class="p-button-raised p-button-danger" icon="pi pi-trash"/>
              </template>
            </Column> -->
          </TreeTable>
        </div>
    </template>
  </Card>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import TreeTable from 'primevue/treetable'
import Column from 'primevue/column'
import Card from 'primevue/card'
import DatePicker from 'vue2-datepicker'
import InputMask from 'primevue/inputmask'
import $ from 'jquery'

export default {
  name: 'CostCenterSummary',
  data() {
    return {
      editing: false,
      id: null,
      loading: false.value,
      englishDateEnabled: true,
      toDate: null
    }
  },
  mounted() {
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
    this.costCenterSummaryLists()
  },
  methods: {
    async searchCostCenterSummary() {
      this.loading = true
      let response = await this.$store.dispatch('loadCostCenterForSummaryReport', this.toDate)
      this.costCenterSummaryLists = response.data.root
      this.loading = false
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.toDate = this.$store.getters.nepaliNewDate
      }
    },
    nepaliDate() {
      $('#toDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.toDate = $('#toDate').val()
        }
      })
    },
    setEnglishDate() {
      this.toDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    }
  },
  components: {
    Dialog,
    Dropdown,
    DatePicker,
    InputMask,
    Button,
    InputText,
    TreeTable,
    Column,
    Card
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// CostCenterSummary.vue?5c1e8350